import { Icon } from "leaflet";
import { useEffect, useRef, useState } from "react";
import { LayersControl, Marker, Polyline, Popup, useMap } from "react-leaflet";
import { useMapStore } from "../../store/mapStore";
import Legend from "../../components/legends/legends";
// import TextPath from "../../components/UI/TextPath";

const { Overlay } = LayersControl;
const limeOptions = { color: 'red' }
const MissionMapViewLayer = () => {
  const map = useMap()
  const polyref = useRef(null)

  const [missionWaypoints, setMissionWaypoints] = useState([])
  const { storeWaypoints } = useMapStore((state) => state)

  useEffect(() => {
    setMissionWaypoints(storeWaypoints?.map((waypoint) => {
      return [waypoint.lat, waypoint.lng]
    }))
  }, [storeWaypoints])

  useEffect(() => {
    const polyline = polyref.current;
    if (Object.keys(polyline?.getBounds())?.length > 0) {
      map.fitBounds(polyline?.getBounds());
    }
    // var latlngs = polyline.getLatLngs();
    // for (let i = 1; i < latlngs.length; i++) {
    //   const pointA = latlngs[i - 1];
    //   const pointB = latlngs[i];
    //   const distance = map.distance(pointA, pointB).toFixed(2); // Round to 2 decimal places

    //   // Add tooltip to marker positioned between two points
    //   // const midpoint = map.latLngAtVincentyMidpoint(pointA, pointB);
    //   polyline.bindTooltip(`Distance: ${distance}m`, {
    //     permanent: true,
    //     noHide: true,
    //     direction: 'auto', // Automatic tooltip placement
    //     offset: [0, 20] // Adjust vertical offset if necessary
    //   });
    // }

  }, [missionWaypoints])

  const LegendData = [
    {
      title: "Starting Position",
      img: "https://icon-library.com/images/map-marker-icon/map-marker-icon-18.jpg"
    },
    {
      title: "Ending Position",
      img: "https://icon-library.com/images/icon-markers/icon-markers-4.jpg"
    },
    {
      title: "Way Point",
      img: "https://icon-library.com/images/google-map-marker-icon/google-map-marker-icon-9.jpg"
    }
  ]
  return (
    <><Overlay checked name="Overlay Layer">


      <Polyline
        ref={polyref}
        pathOptions={limeOptions}
        positions={missionWaypoints?.length > 0 && missionWaypoints || []}
      >
        {/* {missionWaypoints?.length > 0 ? <TextPath positions={(missionWaypoints?.length > 0 && missionWaypoints) || []} text={"test"} /> : ""} */}
        {missionWaypoints?.map((pos, index) => {
          return index === 0 ? (
            <Marker eventHandlers={{
              mouseover: (event) => event.target.openPopup(),
              mouseout: (event) => event.target.closePopup(),
            }} key={index} position={missionWaypoints?.length > 0 && missionWaypoints[0]} icon={new Icon({
              iconUrl: "https://icon-library.com/images/map-marker-icon/map-marker-icon-18.jpg", iconSize: [30, 30]
            })}>
              <Popup>
                <div className="font-extrabold">Starting Position</div>
                <div>{pos[0]},{pos[1]}</div>
              </Popup>
            </Marker>
          ) : index === missionWaypoints?.length - 1 ? (
            <Marker eventHandlers={{
              mouseover: (event) => event.target.openPopup(),
              mouseout: (event) => event.target.closePopup(),
            }} key={index} position={missionWaypoints?.length > 0 && missionWaypoints[missionWaypoints?.length - 1]} icon={new Icon({ iconUrl: "https://icon-library.com/images/icon-markers/icon-markers-4.jpg", iconSize: [30, 30] })}>
              <Popup>
                <div className="font-extrabold">Ending Position</div>
                <div>{pos[0]},{pos[1]}</div>
              </Popup>
            </Marker>
          ) : <Marker eventHandlers={{
            mouseover: (event) => event.target.openPopup(),
            mouseout: (event) => event.target.closePopup(),
          }} key={index} position={pos} icon={new Icon({ iconUrl: "https://icon-library.com/images/google-map-marker-icon/google-map-marker-icon-9.jpg", iconSize: [30, 30] })}>
            <Popup>
              <div className="font-extrabold">Way Point</div>
              <span >{pos[0]},{pos[1]}</span>
            </Popup>
          </Marker>;
        })}
      </Polyline>
      <Legend data={LegendData} />
    </Overlay>
    </>
  )
}

export default MissionMapViewLayer